// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "iconWrapper-52jWi";
var _4 = "root-3dsK1";
var _5 = "header-trmcU";
var _6 = "listWrapper-3jY-5";
var _7 = "list-3RxR4";
var _8 = "upsaleItem-7zJc-";
var _9 = "content-2exAX";
var _a = "footer-2u4tK";
var _b = "listContent-Q8oPD";
var _c = "listContent_main-2yuXA";
var _d = "button-2OvGk";
export { _1 as "__esModule", _2 as "mobile", _3 as "iconWrapper", _4 as "root", _5 as "header", _6 as "listWrapper", _7 as "list", _8 as "upsaleItem", _9 as "content", _a as "footer", _b as "listContent", _c as "listContent_main", _d as "button" }
export default { "__esModule": _1, "mobile": _2, "iconWrapper": _3, "root": _4, "header": _5, "listWrapper": _6, "list": _7, "upsaleItem": _8, "content": _9, "footer": _a, "listContent": _b, "listContent_main": _c, "button": _d }
